export default __webpack_public_path__ + "static/media/276.6dbb24b3.png";